import { FONT_LIST, fontStack, loadFont } from "@/lib/siteDefaults";

const COLOR_FIELDS = [
  { key: "paper", label: "Fundal (hârtie)" },
  { key: "ink", label: "Text (cerneală)" },
  { key: "char", label: "Fundal Hero" },
  { key: "noir", label: "Secțiuni întunecate" },
  { key: "accent", label: "Accent" },
];

const SPACING = [
  { key: "compact", label: "Compact" },
  { key: "normal", label: "Normal" },
  { key: "spacious", label: "Spațios" },
];

export default function ThemeEditor({ theme, onChange }) {
  const setColor = (k, v) =>
    onChange({ ...theme, colors: { ...theme.colors, [k]: v } });
  const setFont = (k, v) => {
    loadFont(v);
    onChange({ ...theme, fonts: { ...theme.fonts, [k]: v } });
  };
  const setSpacing = (v) =>
    onChange({ ...theme, spacing: { ...theme.spacing, section: v } });

  return (
    <div className="max-w-2xl space-y-12">
      {/* Colors */}
      <section>
        <div className="eyebrow text-ink/60 mb-5">Culori</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {COLOR_FIELDS.map((c) => (
            <div key={c.key} className="flex items-center gap-3 border border-ink/15 p-3">
              <input
                type="color"
                value={theme.colors?.[c.key] || "#000000"}
                onChange={(e) => setColor(c.key, e.target.value)}
                data-testid={`color-${c.key}`}
                className="w-10 h-10 shrink-0 cursor-pointer border border-ink/20 bg-transparent"
              />
              <div className="flex-1 min-w-0">
                <div className="eyebrow text-ink/50">{c.label}</div>
                <input
                  value={theme.colors?.[c.key] || ""}
                  onChange={(e) => setColor(c.key, e.target.value)}
                  className="w-full bg-transparent border-b border-ink/20 text-sm outline-none focus:border-ink mt-0.5 uppercase"
                />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Fonts */}
      <section>
        <div className="eyebrow text-ink/60 mb-5">Fonturi</div>
        <div className="grid sm:grid-cols-2 gap-4">
          {[
            { key: "display", label: "Titluri (display)" },
            { key: "body", label: "Corp text" },
            { key: "serif", label: "Serif (editorial)" },
          ].map((f) => (
            <div key={f.key} className="border border-ink/15 p-3">
              <div className="eyebrow text-ink/50 mb-2">{f.label}</div>
              <select
                value={theme.fonts?.[f.key] || "Switzer"}
                onChange={(e) => setFont(f.key, e.target.value)}
                data-testid={`font-${f.key}`}
                className="w-full bg-transparent border border-ink/20 px-2 py-1.5 text-sm outline-none focus:border-ink"
              >
                {FONT_LIST.map((name) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
              <div
                className="mt-3 text-3xl leading-none"
                style={{ fontFamily: fontStack(theme.fonts?.[f.key]) }}
              >
                Ag — Strategie
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Spacing */}
      <section>
        <div className="eyebrow text-ink/60 mb-5">Spațiere secțiuni</div>
        <div className="flex gap-2">
          {SPACING.map((s) => {
            const active = (theme.spacing?.section || "normal") === s.key;
            return (
              <button
                key={s.key}
                onClick={() => setSpacing(s.key)}
                data-testid={`spacing-${s.key}`}
                className={`eyebrow border px-5 py-3 transition-colors ${
                  active ? "bg-ink text-paper border-ink" : "border-ink/25 hover:border-ink"
                }`}
              >
                {s.label}
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
